import React from "react";
import "../assets/styles/dogportrait.css";

function DogPortrait() {
  return (
    <div className="dogportrait-container">
      <h1 className="dogportrait-title">dog portraits</h1>
      <img
        className="dogportrait-image"
        src={require("../assets/images/oscar.jpg")}
        alt="custom dog portrait"
      />
      <div className="dogportrait-text">
        <p>
          Capturing the unique character and spirit of dogs has become one of
          the most joyful aspects of my artistic journey.
        </p>
        <p>
          It all started with a portrait of my own sprollie that turned into a
          series of commissions. Since then, these portraits have grown into a
          cherished part of my art practice.
        </p>
        <p>
          Every dog has a story—a glint in their eyes, a tilt of the head, or a
          favourite toy that says everything about who they are. My goal is to
          capture those little details in a way that feels alive and personal.
        </p>
        <p>
          I work from high-quality photos and take time to get to know a little
          about each dog before I begin. Whether it's a soft pencil sketch, a
          richly layered oil painting, or a whimsical watercolour, each portrait
          is created with care and love.
        </p>
        <p>
          Many of the portraits are gifted to mark special moments—birthdays,
          anniversaries, or in loving memory of a beloved companion. These
          pieces often become treasured keepsakes.
        </p>
        <p>
          If you're thinking about commissioning a dog portrait, please don’t
          hesitate to get in touch. I’ll be happy to guide you through the
          process and work with you to create something truly meaningful.
        </p>
        <p>Guide price: </p>
        <p>15"x15" framed oil - £350 </p>
        <p>A4 pen/ink/watercolour - £250</p>
        <p>
          Thank you for considering my work. I’d be honoured to paint your furry
          friend.
        </p>
      </div>
    </div>
  );
}

export default DogPortrait;
